module.exports = __webpack_public_path__ + "img/img_word@2x (2).365c303.png";